import {parsePhoneNumberFromString} from 'libphonenumber-js';
import Type from './Type';
import FormatException from 'sap/ui/model/FormatException';
import ParseException from 'sap/ui/model/ParseException';
import ValidateException from 'sap/ui/model/ValidateException';

export type MCPhoneFormatOptions = {
    internal? : boolean; // Whether to format as internal number
};

export default class MCPhone extends Type {
    private formatOptions: MCPhoneFormatOptions;

    constructor(formatOptions?: MCPhoneFormatOptions) {
        super();
        this.formatOptions = formatOptions || { internal: false };
    }

    formatValue(value: string): string {
        if (!value) {
            return ""; 
        }
        try {
            const phoneNumber = parsePhoneNumberFromString(value);
            if (this.formatOptions.internal) {
                return phoneNumber.nationalNumber;
            } else {
                return phoneNumber.formatInternational();
            }
        } catch {
            throw new FormatException(`Invalid phone number: ${value}`) as Error;
        }
    }

    parseValue(value: string): string {
        if (!value) {
            return "";
        }
        try {
            const phoneNumber = parsePhoneNumberFromString(value);
            return phoneNumber.number; // Return in E.164 format
        } catch {
            throw new ParseException(`Invalid phone number format: ${value}`) as Error;
        }
    }

    validateValue(value: string): void {
        if (!value) {
            throw new ValidateException("Value cannot be empty") as Error;
        }
        try {
            const phoneNumber = parsePhoneNumberFromString(value);
            if (!phoneNumber || !phoneNumber.isValid()) {
                throw new ValidateException(`Invalid phone number: ${value}`) as Error;
            }
        } catch {
            throw new ValidateException(`Invalid phone number: ${value}`) as Error;
        }
    }
}
    